import Constants from '../Constants.js';


const BoardStyles = {
    BoardOuter: {
        touchAction: 'none',
        position: 'absolute',
        top: 0,
        width: '100%',
        height: '100%',
    },
    BoardWrapper: {
        touchAction: 'none',
        position: 'absolute',
        //top: 0,
        //top: 'constant(safe-area-inset-top)',
        //top: 'env(safe-area-inset-top)',
        //left: '0',
        //right: '0',
        //bottom: 'constant(safe-area-inset-bottom)',
        //bottom: 'env(safe-area-inset-bottom)',
        width: '100%',
        height: '100%',
    },
    BoardContainer: {
        position: 'absolute',
        overflow: 'visible',
        transition: 'top 1500ms, transform 1500ms, background-color 400ms'
    },
    Tile: {
        position: 'absolute',
        width: Constants.tileSize + 'px',
        height: Constants.tileSize + 'px',
        transition: 'background-color 400ms',
    },
    OuterTile: {
        transition: 'background-color 400ms'
    },
    OuterTileInner: {
        height: '100%',
        width: '100%',
        transition: 'background-color 400ms'
    },
    InnerTile: {
        left: Constants.tileSize + 'px',
        transition: 'background-color 400ms'
    },
    SelectedWordFade: {
        position: 'absolute',
        width: '40px',
        height: '100%',
    },
    SelectedWordWrapper: {
        position: 'absolute',
        width: '100%',
        overflow: 'hidden',
        textAlign: 'center',
        fontSize: '30px',
        minWidth: '320px',
        bottom: '100%',
        left: '50%',
        textTransform: 'lowercase',
        transition: 'transform 200ms',
    },
    StateIndicator: {
        left: '10px',
        position: 'absolute',
        borderRadius: '5px',
        padding: '2px 10px',
        color: '#fff',
        fontSize: '12px',
        zIndex: '1',
    }
}


export default BoardStyles;
